"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPropertiesToColumns = exports.propertiesToColumns = void 0;
const react_1 = __importDefault(require("react"));
const hooks_1 = require("common/hooks");
const core_1 = require("react-hook-schema/core");
const getByPath = (obj, paths, pathIndex = 0) => {
    if (pathIndex === paths.length - 1) {
        return obj === null || obj === void 0 ? void 0 : obj[paths[pathIndex]];
    }
    else {
        const target = obj === null || obj === void 0 ? void 0 : obj[paths[pathIndex]];
        return getByPath(target, paths, pathIndex + 1);
    }
};
const propertyToColumn = (schemaComponents, { propertyName, propertyId, schema, title, width }) => {
    const resolve = (0, core_1.createResolver)(schemaComponents);
    const { display: Display } = resolve(schema.schemaType);
    if (Display) {
        return {
            accessor: propertyName || propertyId || "",
            Header: (0, hooks_1.resolveStringIntl)(title),
            Cell: ({ row }) => {
                return (react_1.default.createElement(Display, { value: propertyName
                        ? getByPath(row.original, propertyName.split("."))
                        : row.original, schema: schema }));
            },
            width,
        };
    }
    else if (schema.schemaType !== "object") {
        return {
            Header: (0, hooks_1.resolveStringIntl)(title),
            accessor: propertyName || propertyId || "",
        };
    }
};
const propertiesToColumns = (schemaComponents, properties) => properties
    .map(propertyToColumn.bind(null, schemaComponents))
    .filter((v) => v);
exports.propertiesToColumns = propertiesToColumns;
const createPropertiesToColumns = (schemaComponents) => (properties) => (0, exports.propertiesToColumns)(schemaComponents, properties);
exports.createPropertiesToColumns = createPropertiesToColumns;
